import { Button, Flex, Heading, Modal, Text } from '@modusign/design-system';
import { useGetDocument } from '@modusign/openapi-client-external-document';
import { useDispatch, useSelector } from 'react-redux';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { useInvalidateDocumentList } from '@app/routes/Documents/useDocumentList';
import { blockDocument } from '@app/store/documents/actions';
import { modalClose } from '@app/store/modal/actions';
import { getName } from '@app/store/user/user/selectors';

interface DocumentBlockModalComponentProps {
  documentId: string;
}

export default function DocumentBlockModalComponent({
  documentId,
}: DocumentBlockModalComponentProps) {
  const workspaceId = useWorkspaceId();

  const dispatch = useDispatch();
  const invalidate = useInvalidateDocumentList();
  const userName = useSelector(getName);
  const { refetch } = useGetDocument(workspaceId, documentId);

  return (
    <Modal
      isOpen
      maxWidth="xxs"
      onClose={() => {
        dispatch(modalClose());
      }}
    >
      <Flex alignItems="center" flexDirection="column" gap={7}>
        <Heading fontSize="md">문서 확인 차단</Heading>
        <Text>
          요청자
          <Text fontWeight="medium" ml={1}>
            {userName}
          </Text>
          님을 제외한 모든 서명자들이 문서를 볼 수 없습니다.
        </Text>
        <Flex gap={4}>
          <Button
            type="button"
            onClick={() => {
              dispatch(modalClose());
            }}
          >
            취소
          </Button>
          <Button
            type="submit"
            variant="primary"
            onClick={() => {
              dispatch(modalClose());
              dispatch(blockDocument({ documentId, invalidate }));
              refetch();
            }}
          >
            확인
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
